<header class="fdk-header">
  @if (testMode) {
    <div
      class="fdk-header__test-mode"
      role="status">
      <span>{{ testModeText }}</span>
    </div>
  }

  <div class="fdk-header__main">
    <div class="fdk-header__leading-brand">
      @if (showBackButton) {
        <div class="fdk-header__leading">
          <fdk-icon-button
            icon="chevron-left"
            aria-label="Go back"
            variant="secondary"
            (click)="back.emit()" />
        </div>
      }

      <div
        class="fdk-header__brand"
        [class.fdk-header__brand--wide]="logoIsWide">
        @if (logoUrl) {
          <img
            class="fdk-header__logo"
            [src]="logoUrl"
            [alt]="logoAlt || name"
            (load)="handleLogoLoad($event)"
            (error)="handleLogoError()" />
        } @else if (name) {
          <span class="fdk-header__name">{{ name }}</span>
        } @else {
          <ng-content select="fdk-logo" />
        }
      </div>
    </div>

    <div class="fdk-header__actions">
      @if (showReportIssueButton) {
        <fdk-icon-button
          icon="support"
          aria-label="Report an issue"
          variant="secondary"
          (click)="reportIssue.emit()" />
      }

      @if (showProfileButton) {
        <fdk-icon-button
          icon="user"
          aria-label="Open profile"
          variant="secondary"
          (click)="profile.emit()" />
      }

      @if (showCloseButton) {
        <fdk-icon-button
          icon="cross"
          aria-label="Close"
          variant="secondary"
          (click)="close.emit()" />
      }
    </div>
  </div>
</header>
